export default "__VITE_ASSET__nib9kuA2__"